var smileyForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function SmileyFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedSmilies = [];
        ctrl.smilies = [
            {
                id: 'targeted',
                label: 'Målrettet',
                selected: false,

            },
            {
                id: 'dutiful',
                label: 'Pligtopfyldende',
                selected: false
            },
            {
                id: 'responsible',
                label: 'Ansvarlig',
                selected: false
            },
            {
                id: 'thoughtful',
                label: 'Betænksom',
                selected: false
            },
            {
                id: 'disciplined',
                label: 'Disciplineret',
                selected: false
            },
            {
                id: 'nice',
                label: 'Flink',
                selected: false
            },
            {
                id: 'diligent',
                label: 'Flittig',
                selected: false
            },
            {
                id: 'creative',
                label: 'Kreativ',
                selected: false
            },
            {
                id: 'brave',
                label: 'Modig',
                selected: false
            },
            {
                id: 'careful',
                label: 'Omhyggelig',
                selected: false
            },
            {
                id: 'caring',
                label: 'Omsorgsfuld',
                selected: false
            },
            {
                id: 'imaginative',
                label: 'Opfindsom',
                selected: false
            },
            {
                id: 'productive',
                label: 'Produktiv',
                selected: false
            },
            {
                id: 'punctual',
                label: 'Punktlig',
                selected: false
            },
            {
                id: 'calm',
                label: 'Rolig',
                selected: false
            },
            {
                id: 'funny',
                label: 'Sjov',
                selected: false
            },
            {
                id: 'extrovert',
                label: 'Udadvendt',
                selected: false
            },
            {
                id: 'eloquent',
                label: 'Veltalende',
                selected: false
            },

        ];
       

        function init () {
        }

        function link () {
        }

        function onChanges (changes) {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedSmilies.length === 3) {
                formData.smilies = selectedSmilies;
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('<span class="smiley-icon '+selectedSmilies[0].id+'"></span><span class="smiley-icon '+selectedSmilies[1].id+'"></span><span class="smiley-icon '+selectedSmilies[2].id+'"></span>'),
                        type: 'send'
                    }
                });
                // DataService
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Fedt, du lyder som en cool person 😎 <a href="/din-ansoegning">Godkend dit svar ved at trykke her.</a>'),
                            type: 'receive'
                        }
                    });
                }, 1000);
                
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge 3 smileys.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onSmileyChange = function onSmileyChange(target){
            if(selectedSmilies.length == 3) {
                target.selected = false;
            }
            selectedSmilies = _.chain(ctrl.smilies).filter({'selected':true}).map(function(value){
                var smiley = {
                    id: value.id,
                    label: value.label
                };
                return smiley;
                
            }).value();
            // console.log("onSmileyChange", selectedSmilies);
        };

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl: './angular/components/smiley-form.component.html',
};